<template>
  <div class="coupon-valid">
    <scroller
      lock-x scrollbar-y
      v-if="couponValidList.length > 0">
      <div>
        <div :key="index" v-for="(item, index) in couponValidList" class="coupon-valid__item coupon-card">
          <div class="coupon-valid__item-header">
            <span class="coupon-card__title">{{ item.title }}</span>
            <span class="coupon-card__store">{{ item.store }}</span>
          </div>
          <div class="coupon-valid__item-body">
            <div class="coupon-card__desc">{{ item.description }}</div>
            <div class="coupon-card__price">价值 {{ item.amount | toYuan }} 元</div>
          </div>
          <div class="coupon-valid__item-footer">
            <span class="coupon-card__item-date">
              有效期：{{ item.start_time }} - {{ item.end_time }}
            </span>
            <span class="coupon-card__plate-number">
              {{ item.plate_number }}
            </span>
          </div>
        </div>
        <div class="coupon-valid__blank"></div>
      </div>
    </scroller>

    <div class="coupon-valid__empty" v-if="couponValidList.length === 0 && completed">
      <no-car title="暂无优惠券"></no-car>
    </div>
  </div>
</template>

<script>
import {
  Scroller
} from '@lx-frontend/cvux'
import NoCar from '../components/NoCar'
export default {
  data() {
    return {
      params: {
        owner_id: this.$route.query._owner_id || '',
        sender_id: this.$route.query._sender_id || '',
        store_id: this.$route.query._from_store_id || ''
      },
      couponValidList: [],
      completed: false
    }
  },
  created() {
    this.getValidList()
  },
  components: {
    Scroller,
    NoCar
  },
  methods: {
    async getValidList() {
      const queryParams = { ...this.params }
      this.completed = false
      const {
        code,
        message,
        data = []
      } = await this.$rest.coupon.getValidCouponList(queryParams)

      if (code !== 0) {
        this.showToast(message)
        this.completed = true
        return
      }

      this.couponValidList = data
      this.completed = true
    }
  },
  filters: {
    toYuan(val) {
      return val ? (+val / 100).toFixed(2) : '--'
    }
  }
}
</script>

<style scoped lang="less">
@import "../../stylesheets/modules/coupon/valid";
</style>
